import React from "react";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import CardTitle from "react-md/lib/Cards/CardTitle";
import {DebugElement} from "../../../Atollon/debug";

const Identification = ({ history, identifier }) => {
  return (
    <Card className="card">
      <DebugElement text={"src/components/settings/organizationEdit/Identification.js"}/>
      <CardTitle title="IDENTIFIKACE" />
      <CardText>
        <div className="flex-row">
          <p className="profile-label">Identifikátor organizace:</p>
          <p>{identifier}</p>
        </div>
        <div className="flex-row">
          <p className="profile-label">Domovská stránka:</p>
          <p>
            <span
              className="link"
              onClick={() => history.push(`/${identifier}`)}
            >
              {identifier}
            </span>
          </p>
        </div>
      </CardText>
    </Card>
  );
};

export default Identification;



// WEBPACK FOOTER //
// ./src/components/settings/organizationEdit/Identification.js